var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportsMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,44H9c-1.6542969,0-3-1.3457031-3-3V7c0-1.6542969,1.3457031-3,3-3h18c1.6542969,0,3,1.3457031,3,3h2 c0-2.7568359-2.2431641-5-5-5H9C6.2431641,2,4,4.2431641,4,7v34c0,2.7568359,2.2431641,5,5,5h18c2.7568359,0,5-2.2431641,5-5h-2 C30,42.6542969,28.6542969,44,27,44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7070312,16.2929688l-1.4140625,1.4140625L37.5859375,23c0.0012817,0.0012817,0.001709,0.0031738,0.0029907,0.0044556 L22,23v2l15.5814819,0.0044556l-5.2885132,5.2885132l1.4140625,1.4140625L39,26.4140625C39.6445312,25.7695312,40,24.9121094,40,24 s-0.3554688-1.7695312-1-2.4140625L33.7070312,16.2929688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,9c-8.2714844,0-15,6.7285156-15,15s6.7285156,15,15,15s15-6.7285156,15-15S39.2714844,9,31,9z M31,37 c-7.1679688,0-13-5.8320312-13-13s5.8320312-13,13-13s13,5.8320312,13,13S38.1679688,37,31,37z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportsMedium);
export default __webpack_public_path__ + "static/media/exports--medium.034f4f141b6486784ced74bccbe151bc.svg";
export { ForwardRef as ReactComponent };